import React from "react";
import Header from "../components/Header";
import CalltoActionSection from "../components/homeComponents/CalltoActionSection";
import Footer from "../components/Footer";

const AboutScreen = () => {
  return (
    <>
      <Header />
      <div className="about-container">
        <div className="about-image">
          <img
            src="/images/potraitnobg.png"
            alt="KD Portrait"
            className="portrait-image"
          />
        </div>
        <div className="about-content">
          <div className="about-text">
            <h2>About Me<br/><br/></h2>
            <h3>Welcome to My Art Journey<br/></h3>
            <p>
              Hi, I'm Kinyanjui Denis, the creative mind behind Kinyanjui Arts. My journey
              with acrylic painting started as a simple outlet for self-expression, and
              it has grown into a passionate pursuit. With every brushstroke, I capture
              the essence of the world around me—from the rich landscapes of Africa to the
              emotions woven into our daily lives.
            </p>
            <p>
              My work is a reflection of both personal exploration and universal experiences.
              I blend bold, vibrant colors with intricate details, crafting paintings that tell
              stories of joy, contemplation, and beauty. Through each piece, I aim to share
              not just my perspective but to evoke a connection with those who view it.
            </p>
            <p>
              Thank you for visiting my gallery. I hope my artwork resonates with you and brings
              as much inspiration as I felt while creating it.
            </p>
          </div>
        </div>
      </div>
      <CalltoActionSection />
      <Footer />
    </>
  );
};

export default AboutScreen;
